import BC from '../init';

export default BC.Methods.headerScroll = () => {
    
    const header = document.querySelector('.header');
    const introSection = document.querySelector('.intro-section');
    const introSliderSection = document.querySelector('.intro-slider-section');

    const onScroll = () => {
        const scroll = document.documentElement.scrollTop
        if (scroll > 0) {
            header.classList.add('scrolled');
        } else {
            header.classList.remove('scrolled');
        }
    };

    const onLoad = () => {
        if (introSection === null && introSliderSection === null) {
            header.classList.add('constant');
        }
    };

    onLoad();

    window.addEventListener('scroll', onScroll);
};
